import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: { //组件的状态
      login:'',
      url:'https://www.qijmed.com/api'
      // url:'http://192.168.1.231:8224'
  },
  mutations: { //改变的方法集
      getLogin(state,data){
          state.login = data
      }
  },
  actions: {

  }
})
